import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { HOMEPAGE_POPULAR_CITIES_CLICK } from '../../core/analytics/events';
import { analyticsTrackEvent } from '../../core/analytics';
import { getCityDirectoryUrl } from '../../core/util/seo';
import { isEmptyArray } from '../../core/util/array';
import { colors } from '../../constants/colors';
import { fontFamily, fontSize } from '../../constants/text';
import { smallerThan } from '../../core/util/styledComponents';
import { BASE_URL } from '../../config/index';

const Root = styled.div`
  background: ${colors.fiveSevenNineGrey};
  padding: 72px 20px 0;
  text-align: center;
`;

const Title = styled.h2`
  color: ${colors.darkText};
  font-size: ${fontSize.large};
  font-family: ${fontFamily.bold};
`;

const CityContainer = styled.div`
  padding: 34px 24px 72px;
  margin: 0 auto;
  max-width: 800px;
  display: flex;
  flex-wrap: wrap;
`;

const City = styled.a`
  display: block;
  width: 25%;
  font-size: ${fontSize.mediumSmall};
  font-family: ${fontFamily.book};
  padding: 5px 0;
  text-align: left;

  && {
    color: ${colors.lightGray};
  }

  ${smallerThan.tablet`
    width: 50%;
  `}
`;

const mapStateToProps = (state: any) => ({
  popularCities: state.popularCities.result,
});

type PopularCitiesProps = {
  popularCities?: {
    city: string;
    id?: string;
    name?: string;
    // eslint-disable-next-line camelcase
    solv_partner_locations_count?: number;
    state: string;
    // eslint-disable-next-line camelcase
    viewable_locations_count?: number;
  }[];
};

const PopularCities = (props: PopularCitiesProps) => {
  const onPopularCityClick = (city: any, state: any) =>
    analyticsTrackEvent(HOMEPAGE_POPULAR_CITIES_CLICK, { city, state });

  const { popularCities } = props;
  if (isEmptyArray(popularCities)) {
    return null;
  }

  return (
    <Root>
      <Title>Find an urgent care center near you</Title>

      <CityContainer>
        {popularCities?.map((popular) => (
          <City
            href={`${BASE_URL}${getCityDirectoryUrl(popular.state, popular.city.toLowerCase())}`}
            key={popular.id}
            onClick={() => onPopularCityClick(popular.city, popular.state)}
          >
            {popular.city} Urgent Care
          </City>
        ))}
      </CityContainer>
    </Root>
  );
};

export default connect(mapStateToProps)(PopularCities);
